import { LOG_MODULES } from './modules';
import { trackException, sanitizeLogData } from './exceptionTracker';
import { getLogListgenUserID, resolveListgenUserID } from './resolveListgenUserID';

const MODULE = LOG_MODULES.UPDATE_PROFILE;

const resolveListgenUserIDForLog = (listgenUserID, agentData) =>
  getLogListgenUserID(
    listgenUserID,
    agentData?.listgenUserID,
    resolveListgenUserID()
  );

export const logProfileUpdateFailed = ({
  error,
  listgenUserID,
  agentData,
  code,
  source,
  data = {},
  httpStatus,
  level = 'error',
}) => {
  trackException({
    module: MODULE,
    code,
    error,
    httpStatus,
    level,
    listgenUserID: resolveListgenUserIDForLog(listgenUserID, agentData),
    data: sanitizeLogData({
      source,
      ...data,
    }),
  });
};

export const logProfileUpdateBlocked = ({
  listgenUserID,
  agentData,
  code,
  source,
  data = {},
}) => {
  trackException({
    module: MODULE,
    code,
    error: new Error(code),
    level: 'warning',
    listgenUserID: resolveListgenUserIDForLog(listgenUserID, agentData),
    data: sanitizeLogData({
      source,
      ...data,
    }),
  });
};
